<template>
  <article class="flex bg-white rounded-3xl h-full overflow-hidden" data-component="CardDiscoverLandscape">
    <AtomLink :url="url" class="flex group w-full">
      <div class="md:w-[194px] md:h-[188px] shrink-0 overflow-hidden">
        <MoleculePicture class="block w-full h-full bg-cover group-hover:scale-110 group-focus:scale-110 transform transition duration-500" :image="image" />
      </div>
      <div
        class="py-8 px-6"
        :class="{ 'text-app-primary-1-red--fire-brick': !theme, 'flex flex-col justify-center text-app-secondary-7-violet--purple-heart': theme === 'education' }"
      >
        <h5 v-if="category" class="md:text-xl font-semibold leading-tight">{{ category.title }}</h5>
        <h5 v-if="subtitle" class="md:text-xl font-semibold leading-tight">{{ subtitle }}</h5>
        <div
          v-if="(category || subtitle) && title"
          class="border-b-2 w-12 my-3"
          :class="{ 'border-app-primary-1-orange--bittersweet border-solid': !theme, 'border-app-secondary-9-blue--turquoise': theme === 'education' }"
        />
        <h4 v-if="title" class="md:text-xl leading-tight" :class="{ 'font-semibold': !theme }">{{ title }}</h4>
      </div>
    </AtomLink>
  </article>
</template>

<script setup lang="ts">
defineProps({
  image: {
    type: Object as PropType<Record<string, any>>,
    required: false,
    default: () => ({
      _xsUrl: '/images/fallback/180x180.png',
      _xsWidth: 180,
      _xsHeight: 180,
    }),
  },
  category: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  title: { type: String, required: true },
  subtitle: { type: String, required: false, default: undefined },
  theme: { type: String, required: false, default: undefined },
  url: { type: String, required: true },
})
</script>
